import { ChildModel, ModelBase } from 'store/model-base';
import { AccountDetail } from './account-detail';
import { LineBySessionId } from './line-by-session-id';
import { LineStatus } from 'my-account/constants';

export class LineTransferBySessionId extends ModelBase {
    public static storeName: string = 'lineTransferBySessionId';

    public transferSessionId: string;
    public creationDate: string;
    public sourceAccount: AccountDetail;
    public targetAccount: AccountDetail;
    public originatingAccount: string;
    public lines: LineBySessionId[];
    public transferPinExpires: string;
    public status: string;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        return super.create<T>(data);
    }
    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'lines',
            model: LineBySessionId
        }];
    }

    public getPendingLineByValue(value: string): boolean {
        return this.lines.some((line: LineBySessionId) => line.lineId === value && (line.status === LineStatus.PENDING || line.status === LineStatus.PENDING_CANCEL));
    }

    public getPendingLineByKey(key: string): boolean {
        return this.lines.some((line: LineBySessionId) => line.lineId === key && (line.status === LineStatus.PENDING || line.status === LineStatus.PENDING_CANCEL));
    }
}

